import { LANGUAGE_CODE } from '@healthhub/react-ui';
import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import { MY_FAMILY_AND_FRIEND_HEALTH_DETAILS_PATH } from '@shared/constants/paths';
import type { RouteConfig } from '@shared/types/common.types';

const PortalFamilyAndFriendsHealthProfilePage = lazy(() => import('./pages/PortalFamilyAndFriendsHealthProfilePage'));

export const FAMILY_AND_FRIENDS_HEALTH_PROFILE_ROUTES: RouteConfig[] = [
  {
    availableLanguages: [LANGUAGE_CODE.zh, LANGUAGE_CODE.ms, LANGUAGE_CODE.ta],
    availableViews: [LayoutType.PORTAL],
    component: () => <PortalFamilyAndFriendsHealthProfilePage />,
    displayTitle: () => '',
    layoutProps: {
      contentClassName: 'lg:max-w-none',
      noStyleContent: true,
    },
    pageType: PageType.PRIVATE,
    path: MY_FAMILY_AND_FRIEND_HEALTH_DETAILS_PATH,
    serviceCatalogCode: '',
    titleTransKey: 'leftNavText.familyAndFriendsDetails',
    translationFile: 'translation',
  },
];
